module.exports = __webpack_public_path__ + "static/restaurant2-2089ed34c54563a66687e1771ff94092.jpg";